export const feedbackListPath = "/feedback";
export const productAlertsListPath = "/product-alerts";

export const feedbackListUrl = () => feedbackListPath;
export const productAlertsListUrl = () => productAlertsListPath;
